/**
 * jurisdiction-ontario.ts — seed of the future Ontario jurisdiction pack.
 *
 * Single source for Ontario-specific facts that were previously hardcoded across the
 * executor surface. Keep this file TINY — the full seam extraction (~185 literals,
 * per the s116 Phase 0 inventory) is a separate designed workstream. Today it holds
 * ONLY the Estate Information Return (EIR) filing deadline.
 *
 * EIR deadline: **180 calendar days after the estate certificate is issued** (O. Reg.
 * 310/09; changed from 90 days effective 2020-01-01). The clock runs from certificate
 * issuance, NOT the date of death (s116 rider). NOTE: the checklist's relative-days
 * due-date is still computed from date-of-death — certificate-issuance anchoring is a
 * design-session item, not this rider.
 */

export const EIR_FILING_DEADLINE_DAYS = 180;
export const EIR_DEADLINE_ANCHOR = "after the estate certificate is issued";
export const EIR_DEADLINE_PHRASE = `within ${EIR_FILING_DEADLINE_DAYS} calendar days ${EIR_DEADLINE_ANCHOR}`;

// EIR filing pointers, for the preparation sheet's self-sufficient footer (s137, D-137).
// Online filing hub (Ministry of Finance) + the official form catalogue page (= form_registry source_url).
export const EIR_ONLINE_PORTAL_URL = "https://www.ontario.ca/page/estate-administration-tax";
export const EIR_OFFICIAL_FORM_URL = "https://forms.mgcs.gov.on.ca/en/dataset/9955";
